import {
  Box,
  Flex,
  Heading,
  Typography,
} from "@sidelinesports/fan-design-system";
import { useCurrentGameQuery } from "../../hooks/use-current-game.ts";
import { RundownStats } from "./RundownStats.tsx";

export const RundownSection = () => {
  const currentGameQuery = useCurrentGameQuery();

  if (!currentGameQuery.data) {
    return <Box height="20rem" />;
  }

  const game = currentGameQuery.data;

  if (game.status === "about_to_start") {
    return (
      <Flex gap={4} py={24} align="center" justify="center" direction="column">
        <Heading level={2}>Game hasn’t started yet!</Heading>
        <Typography color="muted" size="md">
          But there’s still time to change your picks below
        </Typography>
      </Flex>
    );
  }

  return <RundownStats />;
};
